import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';
import restauranteroLogo from '../images/restaurantero-logo-white.png';

const AppHeader = () => {
  const history = useHistory();
  const location = useLocation();
  const isProfileActive = location.pathname.startsWith('/account');

  const handleProfileClick = () => {
    history.push('/account');
  };

  return (
    <div style={{
      backgroundColor: '#4183c4',
      color: 'white',
      padding: '10px 15px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}>
      <div style={{ flex: 1 }}></div> {/* Spacer */}
      
      <img 
        src={restauranteroLogo} 
        alt="restaurantero" 
        style={{ 
          height: '32px',
          maxWidth: '220px'
        }} 
      />
      
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        justifyContent: 'flex-end' 
      }}>
        <div
          onClick={handleProfileClick}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: isProfileActive ? 'rgba(255, 255, 255, 0.2)' : 'transparent',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'background-color 0.2s ease'
          }}
        >
          <Icon 
            name="user outline" 
            size="large" 
            style={{ 
              margin: 0,
              opacity: isProfileActive ? 1 : 0.7
            }} 
          />
        </div>
      </div>
    </div>
  );
};

export default AppHeader; 